import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PollMenu from '../../../menus/PollMenu';
import Editor from '../../Editor';
import { extConfig } from './config';
import presetViewerStyles from '../../../Viewer/presets/Poll/Poll.scss';
import s from './Poll.scss';
const PollEditor = (props)=>{
    const { t } = useTranslation('editor');
    var _props_placeholder;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['editor']
    }, /*#__PURE__*/ React.createElement(Editor, _object_spread_props(_object_spread({}, props), {
        withinModal: true,
        presetId: "poll",
        className: cn(s['root'], presetViewerStyles['root']),
        extensionConfig: extConfig,
        initialContent: props.initialContent,
        placeholder: (_props_placeholder = props.placeholder) !== null && _props_placeholder !== void 0 ? _props_placeholder : t('preset.poll.placeholder')
    }))), /*#__PURE__*/ React.createElement("div", {
        className: cn(s['toolbar'])
    }, /*#__PURE__*/ React.createElement(PollMenu, null)));
};
PollEditor.displayName = 'PollEditor';
export default PollEditor;

//# sourceMappingURL=Poll.js.map